import ShareModalComponent from "./ShareModalComponent";

export default ShareModalComponent;
